/**
 * CSV-writing helpers for the import log download. Pulled out of the
 * step-3 components so the formula-injection defense lives in one place
 * — the threat is the same on every export (Excel/Sheets parses leading
 * =/+/-/@/\t/\r as formula starts) so keep one implementation honest.
 */

import { FORMULA_LEADERS } from './constants';

/**
 * Escape one value for a CSV cell. Prefixes formula-leader values with
 * an apostrophe so the cell renders as text in Excel/Sheets without
 * being interpreted as a formula, then RFC-4180 quotes the result when
 * it contains a comma, newline, or quote.
 */
export function csvField(value: string | number | null | undefined): string {
  const s = value === null || value === undefined ? '' : String(value);
  const safe = s.length > 0 && FORMULA_LEADERS.test(s) ? `'${s}` : s;
  if (safe.includes(',') || safe.includes('"') || safe.includes('\n') || safe.includes('\r')) {
    return `"${safe.replace(/"/g, '""')}"`;
  }
  return safe;
}
